import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import axios from "axios";
import { getUserToken } from "utils/functions/userToken";

export const validateAudienceType = async (audienceType) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-audience-type/`,
            {
               audience_type: audienceType
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateAge = async (ageMin,ageMax) => {
    // Client-side validation: Meta restricts age_min >= 18 and age_max <= 65
    if (ageMin && ageMin < 18) {
        return { success: false, error_min: "Minimum age must be at least 18", data: { age_min: [{ errorMessage: "Minimum age must be at least 18" }], age_max: [] } };
    }
    if (ageMin && ageMin > 65) {
        return { success: false, error_min: "Minimum age cannot exceed 65", data: { age_min: [{ errorMessage: "Minimum age cannot exceed 65" }], age_max: [] } };
    }
    if (ageMax && ageMax < 18) {
        return { success: false, error_max: "Maximum age must be at least 18", data: { age_min: [], age_max: [{ errorMessage: "Maximum age must be at least 18" }] } };
    }
    if (ageMax && ageMax > 65) {
        return { success: false, error_max: "Maximum age cannot exceed 65", data: { age_min: [], age_max: [{ errorMessage: "Maximum age cannot exceed 65" }] } };
    }
    if (ageMin && ageMax && ageMin > ageMax) {
        return { success: false, error_min: "Minimum age cannot be greater than maximum age", data: { age_min: [{ errorMessage: "Minimum age cannot be greater than maximum age" }], age_max: [] } };
    }

    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-age/`,
            {
                age_min: ageMin,
                age_max: ageMax,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateGender = async (gender) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-gender/`,
            {
               gender: gender
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateAudienceRule = async (ruleType,source, operator,daysFrom,daysTo) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-audience-rule/`,
            {
               rule_type: ruleType,
               source: source,
               operator: operator,
               days_from: daysFrom,
               days_to: daysTo,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateRuleType = async (ruleType) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-rule-type/`,
            {
               rule_type: ruleType,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateSource = async (source) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-source/`,
            {
               source: source,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateOperator = async (operator) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-operator/`,
            {
               operator: operator,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateDaysRange = async (daysFrom, daysTo) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-dayrange/`,
            {
               days_from: daysFrom,
               days_to: daysTo,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateBookingWindow = async (bookingStart, bookingClose) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-booking-window/`,
            {
               booking_window_start: bookingStart,
               booking_window_end: bookingClose,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateAudience = async (audiencePayload) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/campaign-audience/validate-audience/`,
            {
               ...audiencePayload,
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const { data } = response;
        const errors = {};

        if(data?.age_min?.length > 0){
            errors.age_min = data.age_min.map(err => err.errorMessage).join(", ");
        }

        if(data?.age_max?.length > 0){
            errors.age_max = data.age_max.map(err => err.errorMessage).join(", ");
        }

        if(data?.booking_window_start?.length > 0){
            errors.booking_window_start = data.booking_window_start.map(err => err.errorMessage).join(", ");
        }

        if(data?.booking_window_end?.length > 0){
            errors.booking_window_end = data.booking_window_end.map(err => err.errorMessage).join(", ");
        }

        if(data?.gender?.length > 0){
            errors.gender = data.gender.map(err => err.errorMessage).join(", ");
        }

        if(data?.audience_type?.length > 0){
            errors.audience_type = data.audience_type.map(err => err.errorMessage).join(", ");
        }

        if(data?.rules){
            Object.keys(data.rules).forEach((ruleKey) => {
                const ruleErrors = data.rules[ruleKey];
                if(ruleErrors.length === 0 || !ruleErrors) return;
                errors[`rules.${ruleKey}`] = Array.isArray(ruleErrors) ? ruleErrors.map(err => err.errorMessage).join(", ") : ruleErrors?.errorMessage;
            });
        }

        return { success: true, data: response.data, errors };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};